import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { ButtonV3, rlibfn } from 'react-ui-lib';

import './Body.scss';
import BodyTabs from '../BodyTabs';

import { 
    getGenericData, 
    updateCurrentTabStatus, 
    upsertBotConfigData, 
    blockUiFun, 
    downloadBotConfigData, 
    getSelectedBotData, 
    resetVersion, 
    updateCreateMenuVisiblity, 
    updateCreateMenuData, 
    getBotInfo
} from '../../Redux/Actions/uiActions';
import { bindActionCreators } from "redux";

import MOREICON from '../../../assets/icons/ic_more_horzt_blue.png';
import CLOSEICON from '../../../assets/icons/ic_close_grey_dark.png';
import OPENICON from '../../../assets/icons/ic_opne_white.png';
import COPYICON from '../../../assets/icons/ic_copy.png';
import CreateConfig from '../CreateConfig';
import ImportConfig from '../ImportConfig';
import Logs from '../Logs';
import { Modal, DropdownButton } from "react-ui-lib";
import GenericTab from '../GenericTab';
import { Button } from 'react-bootstrap';

import LOGSBLACKICON from '../../../assets/icons/sideNavIcons/ic_logsBlack.png';
import CreateModal from '../../Components/CreateModal';
import { hideSideNavArr } from '../../Utils';
import history from '../../Routers/history';

class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            botDetail: {},
            modalState: 'save',
            isOpen: false,
            isConfigLoaded: false,
            copyState: false,
            error: ''
        }
        this.bodySectionRef = React.createRef();
    }

    componentDidMount() {
        this.props.blockUiFun(true);
        this.firstParam = this.props.location.pathname.split('/')[1];
        if (this.firstParam && this.firstParam === 'createconfig') {
        } else if (this.firstParam && this.firstParam === 'importconfig') {
        } else if (this.firstParam && this.firstParam === 'genericconfig') {
            if (!Object.keys(this.props.genericBotData).length) {
                this.props.getGenericData(this.props.currentLanguage, (res) => {
                    // this.props.blockUiFun(false);
                }, (err) => {
                    console.log('err', err);
                    this.props.blockUiFun(false);
                })
            }
        } else if (this.firstParam) {
            // this.props.getSelectedBotData(this.firstParam);
            // if(!Object.keys(this.props.genericBotData).length) {
            //     this.props.blockUiFun(true);
            //     this.props.getGenericData(this.props.currentLanguage, (res) => {
            //         this.props.blockUiFun(false);
            //     }, (err) => {
            //         console.log('err', err);
            //         this.props.blockUiFun(false);
            //     })
            // }
        }
    }

    componentDidUpdate() {
        if (this.props.availableBotList && this.props.availableBotList.length !== 0
            && !this.state.isConfigLoaded
            && this.firstParam
            && this.firstParam !== 'createconfig'
            && this.firstParam !== 'importconfig'
            && this.firstParam !== 'genericconfig'
            && this.firstParam !== 'bot-list'
        ) {

            this.props.blockUiFun(true);
            if(!localStorage.getItem('bot_id')) {
                localStorage.setItem('bot_id', this.firstParam);
            } else {
                this.firstParam = localStorage.getItem('bot_id');
                // history.replace(`${this.firstParam}/${this.secondParam}`)
            }
            this.props.getBotInfo(this.firstParam);
            this.props.getSelectedBotData(this.firstParam, () => {
                // this.props.blockUiFun(false);
            }, () => {
                this.props.blockUiFun(false);
            });
            if (!Object.keys(this.props.genericBotData).length) {
                this.props.getGenericData(this.props.currentLanguage, (res) => {
                    // this.props.blockUiFun(false);
                }, (err) => {
                    console.log('err', err);
                    this.props.blockUiFun(false);
                })
            }
            this.setState({ isConfigLoaded: true })
        } else {
            // if(this.props.blockedUi)
            //     this.props.blockUiFun(false);
        }

        try {
            let localBuildState = localStorage.getItem('local_build');
            if(!localBuildState) {
                localStorage.setItem('local_build', false);
            }
        } catch(e) {
            localStorage.setItem('local_build', false);
        }
    }

    download = (filename, textToDownload) => {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textToDownload));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    renderBotTabsTitle = (elem, i) => {
        let currentTabInLowerCase = elem.toLowerCase().replace(/ /g, '').replace(/\//g, '');
        let currentActiveTab = this.props.currentActiveTab.toLowerCase().replace(/ /g, '').replace(/\//g, '');
        if (elem === 'Select Bot') {
            return (
                <li className='nav-item active' onClick={() => { this.props.updateCurrentTabStatus(currentTabInLowerCase) }} key={i}>
                    <Link className='nav-link' data-toggle='tab' to={`/`} role='tab' aria-controls={currentTabInLowerCase} aria-selected='true'>{elem}</Link>
                    <div className='underline'></div>
                </li>
            );
        } else if (elem === 'Custom Check') {
            return (
                <li className='nav-item active' onClick={() => { this.props.updateCurrentTabStatus(currentTabInLowerCase) }} key={i}>
                    <Link className='nav-link' data-toggle='tab' to={`/${this.props.selectedBotID}`} role='tab' aria-controls={currentTabInLowerCase} aria-selected='true'>{elem}</Link>
                    <div className='underline'></div>
                </li>
            );
        } else if (elem === 'Settings') {
            return (
                <li className='nav-item active' onClick={() => { this.props.updateCurrentTabStatus(currentTabInLowerCase) }} key={i}>
                    <Link className='nav-link' data-toggle='tab' to={`/${this.props.selectedBotID}/settings`} role='tab' aria-controls={currentTabInLowerCase} aria-selected='true'>{elem}</Link>
                    <div className='underline'></div>
                </li>
            );
        } else if (currentActiveTab === currentTabInLowerCase) {

            return (
                <li className='nav-item active' onClick={() => { this.props.updateCurrentTabStatus(currentTabInLowerCase) }} key={i}>
                    <Link className='nav-link' data-toggle='tab' to={`/${this.props.selectedBotID}/${currentTabInLowerCase}`} role='tab' aria-controls={currentTabInLowerCase} aria-selected='true'>{elem}</Link>
                    <div className='underline'></div>
                </li>
            );
        } else {
            return (
                <li className='nav-item' onClick={() => { this.props.updateCurrentTabStatus(currentTabInLowerCase) }} key={i}>
                    <Link className='nav-link' data-toggle='tab' to={`/${this.props.selectedBotID}/${currentTabInLowerCase}`} role='tab' aria-controls={currentTabInLowerCase} aria-selected='false'>{elem}</Link>
                    <div className='underline'></div>
                </li>
            );
        }
    }

    checkBotInLs = () => {
        try {
            const BotId = window.localStorage.getItem('bot_id');
            if (!BotId && !(this.props.location.pathname.split('/')[1] === ('bot-list') || this.props.location.pathname.split('/')[1] === '')) {
                localStorage.setItem("bot_id", this.props.location.pathname.split('/')[1]);
                this.props.getBotInfo(this.props.location.pathname.split('/')[1]);
            }
        } catch (e) {

        }
    };

    loadLogs = () => {
        this.checkBotInLs();
        return (
            <>
                <div class="tab-title-wrapper configlogs">
                    <div class="tab-title-icon-wrapper">
                        <img src={LOGSBLACKICON} name="Logs" width="24px" height="24px" alt="Logs" />
                    </div>
                    <span class="tab-title-text" title="Logs">Logs</span>
                </div>
                <div className="log-wrapper">
                    <div className="log-header">
                        <div className="heading user">User</div>
                        <div className="heading">Date</div>
                        <div className="heading">Time</div>
                        <div className="heading">Source</div>
                        <div className="heading">Version</div>
                        <div className="heading" style={{'width': 'calc(33.33333% - 120px)'}}>Status</div>
                        <div className="heading">Download</div>
                        <div className="heading">Restore</div>
                    </div>
                    <Logs />
                </div>
            </>
        );
    }

    loadBody = () => {
        this.checkBotInLs();
        const { editableBotData, isCustomBot, selectedBotID, blockUiFun, upsertBotConfigData, resetVersion, downloadBotConfigData, blockedUi, version } = this.props;
        const overlayClass = 'body-blocker-div' + (blockedUi ? ' active' : '');
        return (
            <div style={{ 'height': 'calc( 100vh - 65px )' }}>
                <div className={overlayClass}></div>
                <BodyTabs key={editableBotData.botId ? editableBotData.botId + '' + isCustomBot : selectedBotID + '' + isCustomBot} id={selectedBotID ? selectedBotID : false} />

                {(!hideSideNavArr.includes(window.location.pathname) && editableBotData.botId && isCustomBot) ? <div className='float-icons-wrapper save-config-btn'>

                    <ButtonV3
                        // className='eb-fixed-icon cancel-btn'
                        title='Reset Changes'
                        name = 'Cancel'
                        btnStyleType = 'secondary'
                        btnstyle = {{marginRight: '1rem'}}
                        onClick={
                            (e) => {
                                this.setState({ modalState: 'warning' }, () => { this.toggleModal() })
                            }
                        }
                    />
                    <ButtonV3
                        // className='eb-fixed-icon config-save-button'
                        title='Save Config'
                        name = 'Save'
                        btnstyle = {{marginRight: '1rem'}}
                        onClick={
                            (e) => {
                                if (isCustomBot) {
                                    let maxSession = parseInt(editableBotData.SETTINGS.MAX_SESSIONS.VALUE);
                                    if (isNaN(maxSession)) {
                                        alert('Max session count should be in the range of 1 to 10');
                                        return;
                                    } else {
                                        blockUiFun(true);
                                        editableBotData.CUSTOM_BOT_UI.VALUE = true;
                                        upsertBotConfigData(editableBotData, version, (savedBotData) => {
                                            resetVersion();
                                            blockUiFun(false);
                                            this.setState({ modalState: 'save' }, () => {
                                                this.toggleModal();
                                            });
                                        }, (err) => {
                                            // console.log('err', err);
                                            this.setState({ modalState: 'save-error', error: err }, () => {
                                                this.toggleModal();
                                            });
                                            blockUiFun(false);
                                        });
                                    }
                                } else {
                                    alert("Can't upsert data for non-custom bot");
                                }
                                return;
                            }
                        }
                    />
                    <DropdownButton
                        key='More Option'
                        name=""
                        // color='#8B8B8B'
                        // bgcolor='#fff'
                        // border="1px solid #2A77DB"
                        btnStyleType = 'secondary'
                        className='more-option-button'
                        btnstyle = {{padding: "0rem .5rem" }}
                        div1Style={{
                            // 'marginLeft': '10px',
                            'height': '2.5rem'
                        }}
                        // div2Style={{
                        //     'height': '100%'
                        // }}
                        btnProps={{
                            className: "more-option-btn"
                        }}
                        rightIcon={
                            <img src={MOREICON} alt="MoreOption" width="24px" height="24px" />
                        }
                        rightIconInverted={
                            <img src={MOREICON} alt="MoreOption" width="24px" height="24px" />
                        }
                        list={[
                            {
                                title: "Download Config", action: (e) => {
                                    if (Object.keys(editableBotData).length !== 0) {
                                        blockUiFun(true);
                                        downloadBotConfigData(() => {
                                            blockUiFun(false);
                                        }, () => {
                                            blockUiFun(false);
                                        });
                                    } else {
                                        alert('Please select a bot to download config details')
                                    }
                                }
                            },
                            {
                                title: "Integration Script", action: (e) => {
                                    this.setState({ modalState: 'integration-script' })
                                    this.toggleModal();
                                }
                            }
                        ]}
                        dropDownPosition={{
                            left: "-4.1em",
                            top: "0.2em"
                        }}
                        showDropdown={false}
                        closeOnClickMenuItem={false}
                    />
                </div> : null}
            </div>
        );
    }

    closeWindow = () => {
        this.toggleModal();
    }

    toggleModal = (currState = true) => {
        const { isOpen } = this.state;
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({ isOpen: false });
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }));
        }
    };

    onsubmitCallback = () => {
        this.toggleModal();
        const { blockUiFun, getSelectedBotData, selectedBotID } = this.props;
        blockUiFun(true);
        localStorage.setItem('bot_id', selectedBotID);
        this.props.getBotInfo(selectedBotID);
        getSelectedBotData(selectedBotID, () => {
            blockUiFun(false);
        }, () => {
            blockUiFun(false);
        });
    }

    onCancelCallback = () => {
        this.toggleModal();
    }

    // showFlashMessage = (val) => {
    //     this.setState({ copyState: !val });
    //     setTimeout(() => {
    //         this.setState({ copyState: val });
    //     }, 2000);
    // }

    // copyToClipboard = (str) => {
    //     const el = document.createElement('textarea');
    //     el.value = str;
    //     document.body.appendChild(el);
    //     el.select();
    //     document.execCommand('copy');
    //     document.body.removeChild(el);
    //     this.showFlashMessage(false);
    // };

    integrationModal = () => {
        const { editableBotData, selectedBotID, sourceList } = this.props
        let BotName = editableBotData && editableBotData.SETTINGS && editableBotData.SETTINGS.BOT_NAME && editableBotData.SETTINGS.BOT_NAME.VALUE && editableBotData.SETTINGS.BOT_NAME.VALUE.length ? editableBotData.SETTINGS.BOT_NAME.VALUE : editableBotData.botId;
        let baseBotURL = editableBotData.SETTINGS && editableBotData.SETTINGS.SERVER_IP_PORT.VALUE;
        let iframeScript = (source) => {return `
<!-- Enterprise Bot - Chat Resources START -->
    <script type="text/javascript">
        var currentBotId = '${BotName}';
    </script>
    <script src="${baseBotURL}/dist/${BotName}/ebInitChatWindow.bundle.js${source?.isDefault ? '' : ('?source=' + source?.sourceName || 'webpage')}"></script>
<!-- Enterprise Bot - Chat Resources END -->
        `};
        return (
            <div className='build-modal-body'>
                <header className='build-modal-header'>
                    <h3 className='build-modal-header__text'>Integration Script(s)</h3>
                    <button className='modal-close-button' onClick={this.toggleModal}>
                        <img className='modal-close-icon' height='24px' width='24px' alt='close' src={CLOSEICON} />
                    </button>
                </header>
                <section className='build-modal-body-section'>
                    <div className={'flash-message-for-copy' + (this.state.copyState ? ' show' : '')}>Script Copied !!</div>
                    { sourceList?.length > 0 && sourceList.map((source, index) => {
                        const sourceName = source?.sourceName || 'webpage'
                        return (
                        <div className='build-modal-box' key={sourceName + index} style={index === 0 ? {marginTop: '0'} : {}}>
                        <header className='build-modal-box-header'>
                            <h3 className='build-modal-box-header__text'>{sourceName}</h3>
                            <button className='build-modal-open-link'>
                                <a className='build-modal-box-body__link' target='_blank' href={`${baseBotURL}/${BotName}/iframe${source?.isDefault ? '' : ('?source=' + sourceName)}`}>
                                    <img className='build-modal-open-icon' height='24px' width='24px' alt='open link' src={OPENICON} />
                                    Open bot in new tab
                                </a>
                            </button>
                        </header>
                        <div className='build-modal-box-body'>
                            <pre className='build-modal-box-body__text' >{iframeScript(source)}</pre>
                            <button className='build-modal-copy-link' onClick={() => { rlibfn.copyText(iframeScript(source), rlibfn.showFlashMessage({message: 'Script Copied !!', type: 'success'})) }}>
                                <img className='build-modal-copy-icon' height='24px' width='24px' alt='copy link' src={COPYICON} />
                            </button>
                        </div>
                    </div>)})
    }
                </section>
            </div>
        );
    }

    renderContent = () => {
        const { modalState, error } = this.state;
        if (modalState === 'save') {
            return (
                <div className='modal-body-content'>Current changes saved, now you can publish the bot to apply the changes</div>
            );
        } else if (modalState === 'save-error') {
            let errorMessage = '';
            try {
                errorMessage = error.toString();
            } catch(e) {
                errorMessage = JSON.stringify(error);
            }
            return (
                <div className='build-modal-body'>
                    <section className='build-modal-body-section'>
                        <div className='build-modal-box'>
                            <div className='build-modal-box-body'>
                                Error while saving the changes. Please try again !!<br /><br />Error: 
                                <pre className='build-modal-box-body__text' >{errorMessage}</pre>
                            </div>
                        </div>
                    </section>
                </div>
            );
        } else if (modalState === 'warning') {
            return (
                <div className='modal-body-content'>This will reset all your changes which has not been saved yet. Please confirm to proceed</div>
            );
        } else if (modalState === 'integration-script') {
            return this.integrationModal();
        } else {
            return <div>Done</div>
        }
    };

    render() {
        const { modalState } = this.state;
        this.firstParam = this.props.location.pathname.split('/')[1];
        this.secondParam = this.props.location.pathname.split('/')[2];

        const { isOpen } = this.state;
        const header = {
            title: modalState === 'save-error' ? 'Error' : 'Flash Message',
            closeOnOutsideClick: true,
            style: {
                display: modalState === 'save-error' ? '' : 'none'
            }
        };
        const footer = {
            onSubmit: this.closeWindow,
            submitText: 'Okay',
            disableSubmit: false,
            customStyle: {
                justifyContent: 'flex-end'
            }
        };
        const warningHeader = {
            title: 'Confirmation Message',
            closeOnOutsideClick: true,
            customStyle: {
                justifyContent: 'flex-end'
            }
        };
        const warningFooter = {
            onSubmit: this.onsubmitCallback,
            onCancel: this.onCancelCallback,
            submitText: 'Confirm',
            cancelText: 'Cancel',
            style: {
                // backgroundColor:'blue'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: (modalState === 'integration-script') ? '960px' : '550px'
        };

        const flashModalClass = 'falsh-message-modal-container' + (modalState === 'warning' ? ' normal-modal' : '')

        return (
            <section className='container-fluid body-section no-padding' id='mainBodySection'>
                {
                    (this.firstParam && this.firstParam === 'createconfig') ?
                        <CreateConfig /> :
                        (this.firstParam && this.firstParam === 'importconfig') ?
                            <ImportConfig /> :
                            (this.firstParam && this.firstParam === 'genericconfig') ?
                                <GenericTab /> :
                                (this.firstParam && this.firstParam === this.props.selectedBotID && this.secondParam && this.secondParam === 'logs') ?
                                    this.loadLogs() : this.loadBody()

                }
                <div className={flashModalClass}>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => { this.toggleModal(false) }}
                        header={modalState === 'warning' ? warningHeader : header}
                        footer={modalState === 'warning' ? warningFooter : (modalState === 'integration-script') ? '' : footer}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
                <div className={'create-menu-container' + (this.props.showCreateMenu ? ' active' : '')} onClick={()=>{this.props.updateCreateMenuVisiblity(false);this.props.updateCreateMenuData({})}}>
                    <div className={'create-menu-box create-menu-wrapper' + (this.props.showCreateMenu ? ' active' : '')} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}>
                        {
                            this.props.createMenuData?.selectedMenuType ?
                            <CreateModal
                                className='eb-icon-btn-style update-input'
                                parentArray={this.props.createMenuData.parentArray}
                                selectedMenuType = {this.props.createMenuData.selectedMenuType || 'textfield'}
                                createMenuData={this.props.createMenuData}
                                modalType={this.props.createMenuType}
                                updateCurrentSelectedMenu = {()=>{this.props.updateCreateMenuVisiblity(false);this.props.updateCreateMenuData({})}}
                                closeModal = {()=>{this.props.updateCreateMenuVisiblity(false);this.props.updateCreateMenuData({})}}
                            />
                            :
                            null
                        }
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state?.UiReducer?.selectedBotID ? state.UiReducer.selectedBotID : false,
        isCustomBot: state?.UiReducer?.isCustomBot ? state.UiReducer.isCustomBot : false,
        editableBotData: state?.UiReducer?.editableBotData ? state.UiReducer.editableBotData : false,
        genericBotData: state?.UiReducer?.genericBotData ? state.UiReducer.genericBotData : {},
        currentLanguage: state?.UiReducer?.currentLanguage ? state.UiReducer.currentLanguage : 'en',
        currentActiveTab: state?.UiReducer?.currentActiveTab ? state.UiReducer.currentActiveTab : '',
        version: state?.UiReducer?.version ? state.UiReducer.version : '',
        blockedUi: state?.UiReducer?.blockedUi ? state.UiReducer.blockedUi : false,
        availableBotList: state?.UiReducer?.availableBotList ? state.UiReducer.availableBotList : [],
        showCreateMenu: state?.UiReducer?.showCreateMenu ? state.UiReducer.showCreateMenu : false,
        createMenuData: state?.UiReducer?.createMenuData ? state.UiReducer.createMenuData : {},
        sourceList: state?.UiReducer?.sourceList || [],
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getGenericData,
        updateCurrentTabStatus,
        upsertBotConfigData,
        blockUiFun,
        downloadBotConfigData,
        getSelectedBotData,
        resetVersion,
        updateCreateMenuVisiblity,
        updateCreateMenuData,
        getBotInfo
    },
        dispatch
    );
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Body));